export const get = (element, attribute) => {
  if (!element) {
    console.log(`!!! WARNING (DOM.fns.dataset.get): Unable to get attribute (${attribute}) on element.`, element)
    return null
  }


  return element.getAttribute && element.getAttribute(attribute) || null
}
